import { gql } from "@apollo/client";
export const CHECK_PIN_CODE = gql`
  query ($pinCode: String!, $sku: String!) {
    pin_code(pinCode: $pinCode, sku: $sku) {
      pinCode
      status
      inventory_availability
      delivery_text
    }
  }
`;

export default {
  checkPinCodeQuery: CHECK_PIN_CODE,
};
